import { useEffect, useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import OrderItemPreviewList from '@entities/Order/ui/OrderItemPreviewList/OrderItemPreviewList'
import OrderShopItem from '@entities/Order/ui/OrderShopItem/OrderShoItem'

import {
  OfflinePurchasePosition,
  UserOrder,
  useSingleOfflinePurchaseQuery,
} from '@shared/generated'
import Wrapper from '@shared/ui/wrapper'

import OrderFooter from './OrderFooter'
import OrderHeader from './OrderHeader'
import OrderSummary from './OrderSummary'

import styles from './styles.module.scss'



interface OrderOnlineProps {
  data: UserOrder;
  isInitialOpen?: boolean;
}

export default function OrderShop ({ data, isInitialOpen }: OrderOnlineProps) {
  const [ isDetail, setIsDetail ] = useState(isInitialOpen ?? false)
  const [ wasOpened, setWasOpened ] = useState(isInitialOpen ?? false)

  useEffect(() => {
    if (isDetail && !wasOpened) {
      setWasOpened(true)
    }
  }, [ isDetail, wasOpened ])

  const { data: singleOfflineData, loading } = useSingleOfflinePurchaseQuery({
    variables: { singleOfflinePurchaseId: data.id },
    skip: !wasOpened,
    fetchPolicy: 'no-cache',
  })

  const handleDetailClick = () => {
    setIsDetail((prev) => !prev)
  }

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <OrderHeader
          data={data}
          isDetail={isDetail}
          handleDetailClick={handleDetailClick}
        />

        {isDetail ? (
          loading ? (
            <SkeletonTheme>
              <Skeleton count={1} height={120} style={{ borderRadius: 16 }} />
            </SkeletonTheme>
          ) : singleOfflineData?.singleOfflinePurchase?.positions &&
            singleOfflineData?.singleOfflinePurchase?.positions?.length > 0 ? (
              <div className={styles.root__items}>
                {singleOfflineData.singleOfflinePurchase.positions.map((el) => (
                  <OrderShopItem
                    key={el?.id}
                    data={el as OfflinePurchasePosition}
                  />
                ))}
              </div>
            ) : null
        ) : (
          <OrderItemPreviewList items={data.meta} />
        )}

        {isDetail && <OrderSummary data={data} />}

        {data?.receipts && data?.receipts?.length > 0 && (
          <OrderFooter data={data} />
        )}
      </Wrapper>
    </div>
  )
}
